<template>
    <div class="regimentRoom">
        <div class="main-container">
            <div class="rule">
                <div class="main-container-head">
                    <ul class="breadcrumb">
                        <li><a href="javascript:void(0)">团房预定</a>></li>
                        <li>团房</li>
                    </ul>
                </div>
                <div class="main-left list">
                    <div>
                        <div class="title">团房需求</div>
                        <div class="condition-item">
                            <div class="label">需求类型</div>
                            <div class="condition-box">
                                <select v-model="DestType">
                                    <option value="0">酒店</option>
                                    <option value="1">城市/商圈</option>
                                </select>
                            </div>
                        </div>
                        <div class="condition-item">
                            <div class="label">{{DestType==0?'酒店名称':'目的地'}}</div>
                            <div :class="isKeyResultShow?'long condition-box activeInput':'long condition-box'">
                                <input type="text" class="searchAll" data-type="search"  v-model="key" @focus="isKeyResultShow = true" placeholder="搜索关键字" maxlength="50" style="width: 265px">
                                <i v-if="key!=''" class="iconfont icon-guanbi" @click="key=''"></i>

                                <SearchAll :keyword="key" :isKeyResultShow="isKeyResultShow" :DestType="parseInt(DestType)" :productType="'4'" @selectCity="selectCity" @selectHotel="selectHotel" @selectLandmark="selectLandmark"></SearchAll>
                            </div>
                        </div>
                        <div class="condition-item">
                            <div class="label">入住日期</div>
                            <div class="condition-box">
                                <div :class="calendar.show?'date activeInput':'date'" data-type="time" @click="calendar.show = true">
                                    <i class="iconfont icon-calendar"></i>
                                    <span>{{CheckIn}}</span>
                                    <span class="days">{{getDays(CheckIn,CheckOut)}}晚</span>
                                    <span>{{CheckOut}}</span>
                                </div>
                                <transition name="fade">
                                <!-- <transition name="fade" enter-active-class="animated bounceInUp"
                                            leave-active-class="animated fadeOutDown"
                                            :duration="500"> -->
                                    <DatePicker @select="calendar.select" v-if="calendar.show" :start="calendar.start"
                                                :beginDate="calendar.begin" :endDate="calendar.end"></DatePicker>
                                </transition>
                            </div>
                        </div>
                        <div class="condition-item" v-if="minValueShow">
                            <div class="label">   </div>
                            <div class="condition-box" style='color:#ff3604;'>
                                该房起订数量为 {{minValue}} 间
                            </div>
                        </div>
                        <div class="condition-item">
                            <div class="label">间数</div>
                            <div class="condition-box">
                                <input type="number" placeholder="填写总房间数(1~200)" v-model="RoomCount" :min="minValue" max="200" @blur="onBlur" maxlength="3"><i style="right: 240px" v-if="RoomCount!=''" class="iconfont icon-guanbi" @click="RoomCount=''"></i><br>
                                <p>房型早餐 <span></span></p>
                                <div class="room">
                                    <label>双床</label> <input type="number" min="0" v-model="DoubleBedRoomCount" maxlength="3"> <i v-if="DoubleBedRoomCount!=''" class="iconfont icon-guanbi" @click="DoubleBedRoomCount=''"></i>
                                    <span><input type="radio" id="dw" value="0" v-model="DoubleBedBFType"> <label for="dw">无早</label></span>
                                    <span><input type="radio" id="dd" value="1" v-model="DoubleBedBFType"> <label for="dd">单早</label></span>
                                    <span><input type="radio" id="ds" value="2" v-model="DoubleBedBFType"> <label for="ds">双早</label></span>
                                </div>
                                <div class="room">
                                    <label>大床</label> <input type="number" min="0" v-model="BigBedRoomCount" maxlength="3">
                                    <i v-if="BigBedRoomCount!=''" class="iconfont icon-guanbi" @click="BigBedRoomCount=''"></i>
                                    <span><input type="radio" value="0" id="sw" v-model="BigBedBFType"> <label for="sw">无早</label></span>
                                    <span><input type="radio" value="1" id="sd" v-model="BigBedBFType"> <label for="sd">单早</label></span>
                                    <span><input type="radio" value="2" id="ss" v-model="BigBedBFType"> <label for="ss">双早</label></span>
                                </div>
                            </div>
                        </div>
                        <div class="condition-item">
                            <div class="label">预算</div>
                            <div class="condition-box">
                                <!--<select v-model="Budget">-->
                                <!--<option value="50~20000"></option>-->
                                <!--<option value="50~1500">150以下</option>-->
                                <!--<option value="150~300">150-300</option>-->
                                <!--<option value="300~600">300-600</option>-->
                                <!--<option value="600~1000">600-1000</option>-->
                                <!--<option value="1000~20000">1000以上</option>-->
                                <!--</select>-->
                                <input type="number" min="50" max="20000" placeholder="50~20000" v-model="Budget" maxlength="5">
                                <i style="right: 63px" v-if="Budget!=''" class="iconfont icon-guanbi" @click="Budget=''"></i>
                                <span>单间均价</span>
                            </div>
                        </div>
                        <div class="condition-item">
                            <div class="label">需求备注</div>
                            <div class="condition-box">
                                <textarea v-model="Remark" maxlength="500"></textarea>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div class="title">联系人</div>
                        <div class="condition-item">
                            <div class="label">姓名</div>
                            <div class="condition-box">
                                <input type="text" :class="isName?'long error':'long'" v-model="Name" ref="name" maxlength="20">
                                <i v-if="Name!=''" class="iconfont icon-guanbi" @click="Name=''"></i>
                            </div>
                        </div>
                        <div class="condition-item">
                            <div class="label">手机号</div>
                            <div class="condition-box">
                                <input type="text" :class="isPhone?'long error':'long'" v-model="Phone" ref="phone" maxlength="50">
                                <i v-if="Phone!=''" class="iconfont icon-guanbi" @click="Phone=''"></i>
                            </div>
                        </div>
                        <div class="condition-item">
                            <div class="label">邮箱</div>
                            <div class="condition-box">
                                <input type="text" :class="isEmail?'long error':'long'" v-model="Email" ref="email" maxlength="50">
                                <i v-if="Email!=''" class="iconfont icon-guanbi" @click="Email=''"></i>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div class="search-btn" @click="submit()">
                            提交
                        </div>
                    </div>
                </div>
                <div class="main-right">
                    <h4>定制需求流程</h4>
                    <div class="step">
                        <span class="icon tian"></span>
                        <div class="time">10秒</div>
                        <div>快速发布需求</div>
                    </div>
                    <div class="step">
                        <span class="icon phone"></span>
                        <div class="time">10分钟</div>
                        <div>顾问致电沟通</div>
                    </div>
                    <div class="step">
                        <span class="icon bao"></span>
                        <div class="time">30分钟</div>
                        <div>获取报价方案</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import SearchAll from './../../common/cmpnt/regimentRoomSearch/regimentRoomSearch'//模糊搜索
    import DatePicker from './../../common/cmpnt/datePicker/datePicker.vue'//日期

    export default {
        name: "regiment-index",
        components:{
            SearchAll,
            DatePicker
        },
        data: function () {
            return {
                hotelData:"",
                //房间数最小值
                minValue:'1',
                minValueShow:false,
                key:'',
                isKeyResultShow:false,
                DestType:0,
                RoomCount:1,
                DoubleBedRoomCount:1,
                BigBedRoomCount:0,
                DoubleBedBFType:0,
                BigBedBFType:0,
                Name:'',
                Phone:'',
                Email:'',
                isName:false,
                isPhone:false,
                isEmail:false,
                isKey:false,
                CheckIn: this.getDate(1),
                CheckOut: this.getDate(2),
                Remark:'',
                Budget:'',
                calendar: {
                    show: false,
                    start: this.getDate(0),
                    begin: this.getDate(1),
                    end: this.getDate(2),
                    select: (begin, end) => {
                        this.calendar.show = false;
                        if (!begin) {
                            return;
                        }
                        this.calendar.begin = begin;
                        this.calendar.end = end;
                        this.CheckIn = begin;
                        this.CheckOut = end;
                    }
                },
            }
        },
        watch: {
            key(val, oldVal) {
                // if (val && oldVal == '') {
                //     this.isHotCityShow = false;
                //     this.isKeyResultShow = true
                // }
            },
            RoomCount(val,oldVal){
                this.DoubleBedRoomCount = Math.ceil(val/2);
                this.BigBedRoomCount = Math.floor(val/2);
            },
            DoubleBedRoomCount(val){
                if(val<0){
                    this.DoubleBedRoomCount = 0
                    this.BigBedRoomCount = this.RoomCount
                }else{
                    this.BigBedRoomCount = this.RoomCount-val
                }
            },
            BigBedRoomCount(val){
                if(val<0){
                    this.BigBedRoomCount = 0
                    this.DoubleBedRoomCount = this.RoomCount
                }else{
                    this.DoubleBedRoomCount = this.RoomCount-val
                }
            },
        },
        mounted() {
            document.title='团房预订---订房易';
            var that = this
            if(that.dao.get('getTFHotel')&&that.$route.query.HotelId){
                var hotel = JSON.parse(that.dao.get('getTFHotel'))
                if(hotel.HotelId==that.$route.query.HotelId){
                    that.hotelData=hotel
                    that.key = hotel.HotelName
                    that.RoomCount = hotel.Count>0?hotel.Count:1
                    that.minValue = hotel.Count>0?hotel.Count:1
                    that.DoubleBedBFType = hotel.BreakfastId=='011003'?2:hotel.BreakfastId=='011002'?1:0
                    that.BigBedBFType = hotel.BreakfastId=='011003'?2:hotel.BreakfastId=='011002'?1:0

                }
            }
            that.$nextTick(() => {
                if(localStorage.getItem('lang')=='t'){
                    that.$zh_tran(localStorage.getItem('lang'))
                }        
            })
        },
        methods: {
            onBlur(){
              if(this.RoomCount === ''|| this.RoomCount < this.minValue){
                  this.RoomCount = this.minValue;
                  this.minValueShow = true
              }
            },
            ExpEmail(){
                var reg = new RegExp("^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$");
                if(this.Email === ''){
                    this.isEmail = true;
                }else if(!reg.test(this.Email)){
                    this.isEmail = true;
                }else{
                    this.isEmail = false;
                }
            },
            ExpPhone(){
                if(this.Phone === ''){
                    this.isPhone = true;
                }else if(!(/^1[3|4|5|7|8]\d{9}$/.test(this.Phone))){
                    this.isPhone = true;
                }else{
                    this.isPhone = false;
                }
            },
            submit(){
                if(this.key === ''){
                    this.error({title:'提示',content:'酒店名称或城市/商圈不能为空！'});
                    return;
                }
                if(this.Name === ''){
                    this.isName = true;
                }else{
                    this.isName = false;
                }

                this.ExpEmail();
                this.ExpPhone();
                // if(this.isName || this.isEmail || this.isPhone){
                //     this.error({title:'提示',content:'请填写正确格式的联系人信息！'});
                // }
                if(this.isName){
                    this.$refs.name.focus();
                    return
                }else if(this.isPhone){
                    this.$refs.phone.focus();
                    return
                }else if(this.isEmail){
                    this.$refs.email.focus();
                    return
                }

                var that = this;
                var params = {
                    DestType:that.DestType,
                    Dest:that.key,
                    CheckIn:that.CheckIn,
                    CheckOut:that.CheckOut,
                    RoomCount:that.RoomCount,
                    DoubleBedRoomCount:that.DoubleBedRoomCount,
                    BigBedRoomCount:that.BigBedRoomCount,
                    BigBedBFType:that.BigBedBFType,
                    DoubleBedBFType:that.DoubleBedBFType,
                    Budget:that.Budget,
                    Remark:that.Remark,
                    ContactName:that.Name,
                    ContactNumber:that.Phone,
                    ContactEmail:that.Email
                };
                that.postRequest({
                    url: that.Api.addTF,
                    params: params
                }).then(res => {
                    if (res && res.IsSuccess) {
                        that.$router.push('/regimentRoomList')
                    } else {
                        that.error({title: '提示', content: res.Msg || '提交失败'})
                    }
                });
            },
            selectCity(city) {
                this.RegionID = city.ID;
                this.From = city.From;
                this.CityName = city.SName;
                this.key = city.CName||city.SName;
                this.isKeyResultShow = false;

                this.Name = '';
                this.LandmarkName = '';
                this.LandmarkCode = '';
            },
            //选择酒店
            selectHotel(hotel) {
                this.isKeyResultShow = false;
                if(!hotel){
                    return
                }
                var obj={
                    ID:hotel.HotelID,
                    From:hotel.From,
                }
                //查询酒店信息
                this.key=hotel.Name
            },
            //选择地标
            selectLandmark(landmark) {
                this.RegionID = landmark.CityID;
                this.CityName = landmark.City;
                this.LandmarkCode = landmark.ID;
                this.LandmarkName = landmark.Name;
                this.From = landmark.From;
                this.key = landmark.Name+','+landmark.City;
                this.isKeyResultShow = false;
                this.Name = '';
            },
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/regimentRoom/index.vue